import { render, staticRenderFns } from "./BT21.vue?vue&type=template&id=e8a8e0a6&"
import script from "./BT21.vue?vue&type=script&lang=js&"
export * from "./BT21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports